/**
 * Where the "Sauna Heater Size Calculator" CTA shows: the Electric Sauna Heaters
 * category page and every product filed in that category.
 *
 * Matched on the EBMS tree id, not the slug — an EBMS rename changes the slug
 * (admin:inventre:slug) but never TREE_ID.
 *
 * Products are matched on `treeIds` from /api/product (own folder + INVENMF
 * cross-links), not just `treeId`: a heater's home folder can be elsewhere.
 * Harvia KIP lives in 680 and is only cross-linked into 808. `treeId` is still
 * checked so the CTA keeps working on the heaters that live in 808 if the
 * frontend deploys before a backend that sends `treeIds`.
 */

export const ELECTRIC_HEATERS_TREE_ID = "808";

export const HEATER_CALCULATOR_PATH = "/sauna-heater-size-calculator";

const isElectricHeatersTree = (treeId) => String(treeId ?? "").trim() === ELECTRIC_HEATERS_TREE_ID;

export function isElectricHeatersCategory(treeId) {
  return isElectricHeatersTree(treeId);
}

export function isElectricHeaterProduct(product) {
  if (!product) return false;
  return [product.treeId, ...(product.treeIds || [])].some(isElectricHeatersTree);
}
